// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconIdentificationBadge = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M46.2935 18.1949C46.1269 16.7904 45.2263 16 43.8119 16H39.8904L43.899 3.9743C44.2607 2.88916 43.6198 2 42.476 2H38.359C37.1568 2 36.3675 2.56885 35.9873 3.70941L32 15.6712L28.0128 3.70941C27.6326 2.56885 26.8433 2 25.641 2H21.5241C20.3802 2 19.7393 2.88916 20.101 3.9743L24.1096 16H20.1881C18.7737 16 17.8731 16.7904 17.7065 18.1949C17.1073 23.2465 16.0792 32.0217 16 53.9926C15.9956 55.2284 16.7647 56 18.0004 56H45.9996C47.2354 56 48.0045 55.2284 48 53.9926C47.9209 32.0217 46.8928 23.2465 46.2935 18.1949ZM38 50H26C24.771 50 24 49.2289 24 48C24 46.771 24.771 46 26 46H38C39.229 46 40 46.771 40 48C40 49.2289 39.229 50 38 50ZM32 40C27.0637 40 24 36.9363 24 32C24 27.0637 27.0637 24 32 24C36.9364 24 40 27.0637 40 32C40 36.9363 36.9364 40 32 40Z" />
    </svg>
  );
};
